import type { ConsentState } from "./consent.js";

/** Read the last trustworthy Consent Mode update, before a late second default. */
export function consentFromDataLayer(entries: readonly unknown[]): ConsentState | null {
  let latest: ConsentState | null = null;
  let lateDefault = false;
  for (const raw of entries) {
    if (!raw || typeof raw !== "object") continue;
    const entry = raw as Record<number, unknown>;
    if (entry[0] !== "consent") continue;
    if (entry[1] === "default" && latest) {
      // Consent Mode defaults belong before updates. Pixel Manager has been
      // observed adding a second default and an all-granted update AFTER the
      // visitor rejected the CMP banner. Ignore that later sequence.
      lateDefault = true;
      continue;
    }
    if (entry[1] !== "update" || lateDefault) continue;
    const data = entry[2];
    if (!data || typeof data !== "object") continue;
    const values = data as Record<string, unknown>;
    latest = {
      analytics: values.analytics_storage === "granted" ? "granted" : "denied",
      marketing: values.ad_storage === "granted" ? "granted" : "denied",
    };
  }
  return latest;
}
